<style></style>

<template>
    <div class="my_goals_container mt-5">
        <table class="goals_header">
            <tbody>
                <tr>
                    <td>My Goals</td>
                </tr>
            </tbody>
        </table>
        <table class="goals_content" id="mygoals">
            <tbody>
                <tr id="no_goals_selected" v-if="actionPlans.length == 0">
                    <td class="cell_bottom">Add goals by selecting them above.</td>
                </tr>
                <template v-else>
                    <tr  class="selected_goals" v-for="ap in unfinishedActionPlans" :key="ap.id">
                        <td class="cell_bottom">
                            <div class="left goal_btn">
                                <img class="btn-image" :src="$basePath+'/images/action_plans/'+ap.goal.best_practice.section.btn_image" />
                            </div>
                            <div class="a_goal" v-html="ap.goal.best_practice.text"></div>
                            <div class="close_wrapper">
                                <a :href="'#remove-action-plan='+ap.id" class="close right deleteap" @click.prevent="$emit('removeActionPlan', ap.id)">
                                    <i class="fas fa-times"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: ['actionPlans'],
        computed: {
            unfinishedActionPlans: function () {
                return this.actionPlans.filter(ap => ap.date_completed === null);
            }
        }
    }
</script>